import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createFacilityRuleMutationAtom = createMutationAtomFactory(
  'settings.complianceFacilityRuleCreate',
  (params: {
    facilityId: string;
    ruleDefinitionId: string;
    isEnabled: boolean;
    configuredValue?: { value: string | number | boolean };
    applicableCategoryIds?: string[];
    effectiveFrom?: string;
    effectiveTo?: string;
    notes?: string;
  }) => ({
    complianceComplianceFacilityRuleCreate: {
      __args: {
        input: {
          facilityId: params.facilityId,
          ruleDefinitionId: params.ruleDefinitionId,
          isEnabled: params.isEnabled,
          configuredValue: params.configuredValue,
          applicableCategoryIds: params.applicableCategoryIds,
          effectiveFrom: params.effectiveFrom,
          effectiveTo: params.effectiveTo,
          notes: params.notes,
        },
      },
      id: true,
    },
  }),
);
